import { PSS_LOCAL_STORAGE_KEY } from 'containers/PostSampleSurveyBanner/constants'
import differenceInDaysDateUtil from 'utils/date/difference-in-days'
import getItemLocalStorageUtil from 'utils/local-storage/get-item'
import logUtil from 'utils/log'
import shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil from 'modules/post-sample-survey/redux/utils/should-show-modal-or-banner-based-on-location'
import getReferralCodeFromLocationLoyaltyUtil from 'modules/loyalty/redux/utils/get-referral-code-from-location'

const MIN_DAYS_TO_SHOW_MODAL = 1

/**
 * @param props
 * @param props.isGiftOrSelfGiftingUrl
 * @param props.reminder
 * @param props.shouldShowReferralModal
 * @returns {boolean}
 */
export default function shouldShowModalPostSampleSurveyUtil (props) {
  const {
    reminder,
    shouldShowReferralModal,
    isGiftOrSelfGiftingUrl
  } = props
  logUtil('shouldShowModalPostSampleSurveyUtil').debug('props=', props)

  if (isGiftOrSelfGiftingUrl) {
    return false
  }

  if (
    shouldShowReferralModal ||
    getReferralCodeFromLocationLoyaltyUtil()
  ) {
    logUtil('shouldShowModalPostSampleSurveyUtil').debug('[noop] should show referral code')
    return false
  }

  const closedAt = getItemLocalStorageUtil(PSS_LOCAL_STORAGE_KEY.SURVEY_MODAL_CLOSED_AT)
  let shouldShow
  let daysDiff
  if (closedAt) {
    daysDiff = differenceInDaysDateUtil(new Date(), new Date(closedAt))
  }

  const debugProps = {
    daysDiff,
    closedAt,
    props
  }
  logUtil('shouldShowModalPostSampleSurveyUtil').debug('debugProps=', debugProps)

  if (
    shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil() &&
    reminder && (
      daysDiff == null ||
      daysDiff >= MIN_DAYS_TO_SHOW_MODAL
    )
  ) {
    shouldShow = true
  }
  return shouldShow
}
